import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "./message.service";


export class Utils {

    /**
    * 
    * @param properties Check for null Object
    */
    public static trimToProperties(properties: IPropertyMeta[]) {
        properties.forEach(p => p.value = p.value ? p.value.trim() : "");
    }

    /**
     * @param properties Check for null and pattern
     * @param environMetadataName name of enviroiment
     * @param _translate translate service
     * @param messageService message service
     * 
     */
    public static validateProperties(properties: IPropertyMeta[], 
        _translate: TranslateService, messageService: MessageService) {
        let isRequired = "";
        let environment = "";
        let idNotValid = "";
        _translate.get('GLOBAL.IS_REQUIRED_FIELD').subscribe(translation => {
            isRequired = translation;
        });
        _translate.get('GLOBAL.IS_NOT_VALID').subscribe(translation => {
            idNotValid = translation;
        });
        let succeess = true;
        let valuesMissing: string[] = [];
        valuesMissing = properties.filter(prop => prop.validateMissing()).map(m => m.validateMissing());
        if (valuesMissing.length > 0) {
            succeess = false;
            valuesMissing.reverse().forEach(val => {
                messageService.showError(val + isRequired );
            })
        }
        //validate pattern
        let valuesNoOk: string[] = [];
        valuesNoOk = properties.filter(f => f.value && f.value.length > 0 && f.pattern).filter(f => {
            var urlregex = new RegExp(f.pattern);
            return !urlregex.test(f.value);
        }).map(m => m.name);
        if (valuesNoOk.length > 0) {
            succeess = false;
            valuesNoOk.reverse().forEach(val => {
                messageService.showError(val + idNotValid + environment);
            })
        }
        return succeess;
    }

    public static copyObject<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj));
      }

    public static copyMetaproperties(origin: ITriggerConnection, destine: ITriggerConnection) {
        if(origin.environment.currentEnvironment.params.metaProperties){
            destine.environment.currentEnvironment.params.metaProperties = origin.environment.currentEnvironment.params.metaProperties.map(m => m.clone());;
        }
      }

    public static copyDataTrigger<T>(origin: T, destine: T) {
        for (const key in origin) {
            if (origin.hasOwnProperty(key)) {
                destine[key] = origin[key];
            }
        }
    }

}